import { useEffect } from "react";
import { styles } from "../../config/config.theme";

/**
 * Sets document style properties passed from app-specific configuration file
 */
const Theme = () => {
  useEffect(() => {
    Object.keys(styles).forEach((key) => {
      document.documentElement.style.setProperty(`--${key}`, styles[key]);
    });
  }, []);
  return null;
};

export default Theme;
